import { axios } from "@Root/API";

export const getContactsProgrammesTable = (contactId, params) => {
  return axios.get(`contact/${contactId}/programs`, {
    params
  });
};
